export default __webpack_public_path__ + "static/media/DSC_0539.6d10cee2.jpg";